import { useEffect, useState } from "react";

export const Envelope = ({ onOpen, onDone }) => {
  const [phase, setPhase] = useState(0); // 0 sealed, 1 unsealing, 2 flap-open, 3 card-out, 4 gone

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const start = () => {
    if (phase !== 0) return;
    if (onOpen) onOpen();
    setPhase(1); // seal cracks + light burst
    setTimeout(() => setPhase(2), 650);  // flap opens
    setTimeout(() => setPhase(3), 1650); // card rises
    setTimeout(() => setPhase(4), 3100); // fade out
    setTimeout(onDone, 3900);
  };

  const p = phase;

  return (
    <div
      className={`env-overlay ${p >= 4 ? "fade" : ""}`}
      onClick={start}
      data-testid="envelope-overlay"
    >
      <div className={`env-glow ${p >= 1 ? "on" : ""} ${p >= 3 ? "full" : ""}`} />
      <div className={`env-rays ${p >= 2 ? "on" : ""}`} />
      <div className="env-particles">
        {Array.from({ length: 18 }).map((_, i) => (
          <span key={i} className={`spark s${i} ${p >= 1 ? "go" : ""}`} />
        ))}
      </div>

      <div className="env-center">
        <div className="eyebrow f-corm" style={{ marginBottom: 26 }}>
          Gol Dhana &amp; Engagement of
        </div>
        <div className="env-names f-corm">Nikhil Ahuja &amp; Parita Jagad</div>

        <div className={`envelope stage-${p}`}>
          <div className={`env-flap ${p >= 2 ? "open" : ""}`}>
            <div className="env-flap-inner" />
          </div>
          <div
            className={`env-card ${p >= 3 ? "out" : ""}`}
            style={{ backgroundImage: "url(/assets/blank_hero.png)" }}
          >
            <div className="env-card-shine" />
          </div>
          <div className="env-pocket">
            <div className="env-pocket-shadow" />
          </div>
          <button
            className={`wax-seal ${p >= 1 ? "cracked" : ""}`}
            data-testid="envelope-open-btn"
            onClick={start}
            aria-label="Open invitation"
          >
            <span className="wax-half l" />
            <span className="wax-half r" />
            <span className="wax-mono f-corm">N &amp; P</span>
          </button>
        </div>

        <div className="env-hint f-corm">
          {p === 0 ? "TAP TO OPEN" : "\u00A0"}
        </div>
      </div>
    </div>
  );
};
